"use strict";

require("core-js/modules/es6.array.filter.js");
var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.string.small.js");
require("core-js/modules/es6.string.bold.js");
require("core-js/modules/es6.array.slice.js");
require("core-js/modules/es6.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _add_months = _interopRequireDefault(require("date-fns/add_months"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _get_day = _interopRequireDefault(require("date-fns/get_day"));
var _get_month = _interopRequireDefault(require("date-fns/get_month"));
var _get_year = _interopRequireDefault(require("date-fns/get_year"));
var _is_before = _interopRequireDefault(require("date-fns/is_before"));
var _is_same_month = _interopRequireDefault(require("date-fns/is_same_month"));
var _start_of_day = _interopRequireDefault(require("date-fns/start_of_day"));
var _sub_days = _interopRequireDefault(require("date-fns/sub_days"));
var _gridStyled = require("grid-styled");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _button = _interopRequireWildcard(require("@gravity/button"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _utils2 = require("./utils");
var _jsxFileName = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/MiniCalendar.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17,
  _templateObject18,
  _templateObject19,
  _templateObject20;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_2r8wniypo() {
  var path = "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/MiniCalendar.js";
  var hash = "e9b682b705c3af8b7a7f745a78cd754f4b113bb4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3695197742/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Calendar/lib/MiniCalendar.js",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 33
        },
        end: {
          line: 26,
          column: 49
        }
      },
      "1": {
        start: {
          line: 28,
          column: 16
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "2": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 87
        }
      },
      "3": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 89
        }
      },
      "4": {
        start: {
          line: 48,
          column: 17
        },
        end: {
          line: 50,
          column: 4
        }
      },
      "5": {
        start: {
          line: 52,
          column: 23
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "6": {
        start: {
          line: 61,
          column: 8
        },
        end: {
          line: 61,
          column: 92
        }
      },
      "7": {
        start: {
          line: 78,
          column: 16
        },
        end: {
          line: 96,
          column: 1
        }
      },
      "8": {
        start: {
          line: 81,
          column: 35
        },
        end: {
          line: 86,
          column: 10
        }
      },
      "9": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 84,
          column: 9
        }
      },
      "10": {
        start: {
          line: 83,
          column: 10
        },
        end: {
          line: 83,
          column: 19
        }
      },
      "11": {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 17
        }
      },
      "12": {
        start: {
          line: 88,
          column: 22
        },
        end: {
          line: 92,
          column: 43
        }
      },
      "13": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 21
        }
      },
      "14": {
        start: {
          line: 98,
          column: 16
        },
        end: {
          line: 192,
          column: 2
        }
      },
      "15": {
        start: {
          line: 112,
          column: 10
        },
        end: {
          line: 115,
          column: 25
        }
      },
      "16": {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 127,
          column: 28
        }
      },
      "17": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 133,
          column: 21
        }
      },
      "18": {
        start: {
          line: 134,
          column: 25
        },
        end: {
          line: 134,
          column: 73
        }
      },
      "19": {
        start: {
          line: 138,
          column: 27
        },
        end: {
          line: 138,
          column: 75
        }
      },
      "20": {
        start: {
          line: 166,
          column: 15
        },
        end: {
          line: 168,
          column: 5
        }
      },
      "21": {
        start: {
          line: 180,
          column: 37
        },
        end: {
          line: 180,
          column: 86
        }
      },
      "22": {
        start: {
          line: 194,
          column: 23
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "23": {
        start: {
          line: 200,
          column: 18
        },
        end: {
          line: 216,
          column: 1
        }
      },
      "24": {
        start: {
          line: 218,
          column: 21
        },
        end: {
          line: 241,
          column: 1
        }
      },
      "25": {
        start: {
          line: 227,
          column: 8
        },
        end: {
          line: 227,
          column: 92
        }
      },
      "26": {
        start: {
          line: 229,
          column: 8
        },
        end: {
          line: 229,
          column: 94
        }
      },
      "27": {
        start: {
          line: 243,
          column: 23
        },
        end: {
          line: 263,
          column: 1
        }
      },
      "28": {
        start: {
          line: 265,
          column: 18
        },
        end: {
          line: 282,
          column: 1
        }
      },
      "29": {
        start: {
          line: 284,
          column: 10
        },
        end: {
          line: 290,
          column: 1
        }
      },
      "30": {
        start: {
          line: 292,
          column: 19
        },
        end: {
          line: 296,
          column: 1
        }
      },
      "31": {
        start: {
          line: 295,
          column: 13
        },
        end: {
          line: 295,
          column: 61
        }
      },
      "32": {
        start: {
          line: 298,
          column: 16
        },
        end: {
          line: 301,
          column: 4
        }
      },
      "33": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 90
        }
      },
      "34": {
        start: {
          line: 303,
          column: 24
        },
        end: {
          line: 316,
          column: 1
        }
      },
      "35": {
        start: {
          line: 305,
          column: 22
        },
        end: {
          line: 305,
          column: 33
        }
      },
      "36": {
        start: {
          line: 325,
          column: 4
        },
        end: {
          line: 330,
          column: 5
        }
      },
      "37": {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 329,
          column: 8
        }
      },
      "38": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 16
        }
      },
      "39": {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 335,
          column: 17
        }
      },
      "40": {
        start: {
          line: 336,
          column: 4
        },
        end: {
          line: 339,
          column: 6
        }
      },
      "41": {
        start: {
          line: 340,
          column: 4
        },
        end: {
          line: 340,
          column: 51
        }
      },
      "42": {
        start: {
          line: 344,
          column: 4
        },
        end: {
          line: 344,
          column: 62
        }
      },
      "43": {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 345,
          column: 18
        }
      },
      "44": {
        start: {
          line: 349,
          column: 4
        },
        end: {
          line: 349,
          column: 65
        }
      },
      "45": {
        start: {
          line: 353,
          column: 4
        },
        end: {
          line: 355,
          column: 5
        }
      },
      "46": {
        start: {
          line: 354,
          column: 6
        },
        end: {
          line: 354,
          column: 30
        }
      },
      "47": {
        start: {
          line: 356,
          column: 4
        },
        end: {
          line: 356,
          column: 28
        }
      },
      "48": {
        start: {
          line: 362,
          column: 15
        },
        end: {
          line: 362,
          column: 93
        }
      },
      "49": {
        start: {
          line: 362,
          column: 31
        },
        end: {
          line: 362,
          column: 93
        }
      },
      "50": {
        start: {
          line: 362,
          column: 58
        },
        end: {
          line: 362,
          column: 92
        }
      },
      "51": {
        start: {
          line: 365,
          column: 20
        },
        end: {
          line: 365,
          column: 47
        }
      },
      "52": {
        start: {
          line: 366,
          column: 4
        },
        end: {
          line: 372,
          column: 5
        }
      },
      "53": {
        start: {
          line: 367,
          column: 6
        },
        end: {
          line: 367,
          column: 40
        }
      },
      "54": {
        start: {
          line: 369,
          column: 6
        },
        end: {
          line: 371,
          column: 9
        }
      },
      "55": {
        start: {
          line: 376,
          column: 23
        },
        end: {
          line: 376,
          column: 47
        }
      },
      "56": {
        start: {
          line: 377,
          column: 4
        },
        end: {
          line: 381,
          column: 5
        }
      },
      "57": {
        start: {
          line: 378,
          column: 6
        },
        end: {
          line: 380,
          column: 9
        }
      },
      "58": {
        start: {
          line: 386,
          column: 27
        },
        end: {
          line: 386,
          column: 63
        }
      },
      "59": {
        start: {
          line: 387,
          column: 4
        },
        end: {
          line: 387,
          column: 97
        }
      },
      "60": {
        start: {
          line: 393,
          column: 16
        },
        end: {
          line: 397,
          column: 3
        }
      },
      "61": {
        start: {
          line: 393,
          column: 23
        },
        end: {
          line: 397,
          column: 3
        }
      },
      "62": {
        start: {
          line: 394,
          column: 4
        },
        end: {
          line: 396,
          column: 5
        }
      },
      "63": {
        start: {
          line: 395,
          column: 6
        },
        end: {
          line: 395,
          column: 30
        }
      },
      "64": {
        start: {
          line: 400,
          column: 73
        },
        end: {
          line: 400,
          column: 83
        }
      },
      "65": {
        start: {
          line: 401,
          column: 21
        },
        end: {
          line: 401,
          column: 36
        }
      },
      "66": {
        start: {
          line: 402,
          column: 18
        },
        end: {
          line: 402,
          column: 49
        }
      },
      "67": {
        start: {
          line: 403,
          column: 31
        },
        end: {
          line: 408,
          column: 8
        }
      },
      "68": {
        start: {
          line: 404,
          column: 6
        },
        end: {
          line: 406,
          column: 7
        }
      },
      "69": {
        start: {
          line: 405,
          column: 8
        },
        end: {
          line: 405,
          column: 39
        }
      },
      "70": {
        start: {
          line: 407,
          column: 6
        },
        end: {
          line: 407,
          column: 23
        }
      },
      "71": {
        start: {
          line: 410,
          column: 25
        },
        end: {
          line: 410,
          column: 29
        }
      },
      "72": {
        start: {
          line: 411,
          column: 24
        },
        end: {
          line: 411,
          column: 28
        }
      },
      "73": {
        start: {
          line: 414,
          column: 4
        },
        end: {
          line: 429,
          column: 5
        }
      },
      "74": {
        start: {
          line: 415,
          column: 20
        },
        end: {
          line: 415,
          column: 57
        }
      },
      "75": {
        start: {
          line: 416,
          column: 24
        },
        end: {
          line: 416,
          column: 32
        }
      },
      "76": {
        start: {
          line: 417,
          column: 23
        },
        end: {
          line: 417,
          column: 34
        }
      },
      "77": {
        start: {
          line: 418,
          column: 22
        },
        end: {
          line: 418,
          column: 39
        }
      },
      "78": {
        start: {
          line: 419,
          column: 25
        },
        end: {
          line: 419,
          column: 43
        }
      },
      "79": {
        start: {
          line: 421,
          column: 6
        },
        end: {
          line: 424,
          column: 53
        }
      },
      "80": {
        start: {
          line: 425,
          column: 6
        },
        end: {
          line: 428,
          column: 62
        }
      },
      "81": {
        start: {
          line: 435,
          column: 27
        },
        end: {
          line: 440,
          column: 5
        }
      },
      "82": {
        start: {
          line: 436,
          column: 6
        },
        end: {
          line: 438,
          column: 7
        }
      },
      "83": {
        start: {
          line: 437,
          column: 8
        },
        end: {
          line: 437,
          column: 49
        }
      },
      "84": {
        start: {
          line: 439,
          column: 6
        },
        end: {
          line: 439,
          column: 31
        }
      },
      "85": {
        start: {
          line: 442,
          column: 21
        },
        end: {
          line: 442,
          column: 60
        }
      },
      "86": {
        start: {
          line: 444,
          column: 4
        },
        end: {
          line: 563,
          column: 6
        }
      },
      "87": {
        start: {
          line: 455,
          column: 29
        },
        end: {
          line: 455,
          column: 59
        }
      },
      "88": {
        start: {
          line: 468,
          column: 29
        },
        end: {
          line: 468,
          column: 58
        }
      },
      "89": {
        start: {
          line: 476,
          column: 12
        },
        end: {
          line: 478,
          column: 29
        }
      },
      "90": {
        start: {
          line: 483,
          column: 10
        },
        end: {
          line: 560,
          column: 21
        }
      },
      "91": {
        start: {
          line: 486,
          column: 30
        },
        end: {
          line: 486,
          column: 55
        }
      },
      "92": {
        start: {
          line: 487,
          column: 28
        },
        end: {
          line: 487,
          column: 50
        }
      },
      "93": {
        start: {
          line: 489,
          column: 16
        },
        end: {
          line: 489,
          column: 98
        }
      },
      "94": {
        start: {
          line: 490,
          column: 37
        },
        end: {
          line: 490,
          column: 70
        }
      },
      "95": {
        start: {
          line: 491,
          column: 31
        },
        end: {
          line: 491,
          column: 67
        }
      },
      "96": {
        start: {
          line: 492,
          column: 30
        },
        end: {
          line: 492,
          column: 54
        }
      },
      "97": {
        start: {
          line: 494,
          column: 64
        },
        end: {
          line: 494,
          column: 77
        }
      },
      "98": {
        start: {
          line: 495,
          column: 31
        },
        end: {
          line: 499,
          column: 15
        }
      },
      "99": {
        start: {
          line: 500,
          column: 31
        },
        end: {
          line: 515,
          column: 15
        }
      },
      "100": {
        start: {
          line: 516,
          column: 14
        },
        end: {
          line: 532,
          column: 15
        }
      },
      "101": {
        start: {
          line: 517,
          column: 16
        },
        end: {
          line: 531,
          column: 17
        }
      },
      "102": {
        start: {
          line: 518,
          column: 18
        },
        end: {
          line: 524,
          column: 20
        }
      },
      "103": {
        start: {
          line: 525,
          column: 23
        },
        end: {
          line: 531,
          column: 17
        }
      },
      "104": {
        start: {
          line: 526,
          column: 18
        },
        end: {
          line: 530,
          column: 20
        }
      },
      "105": {
        start: {
          line: 533,
          column: 33
        },
        end: {
          line: 533,
          column: 58
        }
      },
      "106": {
        start: {
          line: 534,
          column: 14
        },
        end: {
          line: 536,
          column: 15
        }
      },
      "107": {
        start: {
          line: 535,
          column: 16
        },
        end: {
          line: 535,
          column: 66
        }
      },
      "108": {
        start: {
          line: 537,
          column: 14
        },
        end: {
          line: 539,
          column: 15
        }
      },
      "109": {
        start: {
          line: 538,
          column: 16
        },
        end: {
          line: 538,
          column: 70
        }
      },
      "110": {
        start: {
          line: 541,
          column: 29
        },
        end: {
          line: 557,
          column: 15
        }
      },
      "111": {
        start: {
          line: 558,
          column: 14
        },
        end: {
          line: 558,
          column: 28
        }
      },
      "112": {
        start: {
          line: 567,
          column: 0
        },
        end: {
          line: 608,
          column: 2
        }
      },
      "113": {
        start: {
          line: 610,
          column: 0
        },
        end: {
          line: 626,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 26
          },
          end: {
            line: 35,
            column: 27
          }
        },
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 87
          }
        },
        line: 36
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 37,
            column: 15
          },
          end: {
            line: 37,
            column: 16
          }
        },
        loc: {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 89
          }
        },
        line: 38
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 60,
            column: 15
          },
          end: {
            line: 60,
            column: 16
          }
        },
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 92
          }
        },
        line: 61
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 80,
            column: 15
          },
          end: {
            line: 80,
            column: 16
          }
        },
        loc: {
          start: {
            line: 80,
            column: 49
          },
          end: {
            line: 94,
            column: 5
          }
        },
        line: 80
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 81,
            column: 36
          },
          end: {
            line: 81,
            column: 37
          }
        },
        loc: {
          start: {
            line: 81,
            column: 42
          },
          end: {
            line: 86,
            column: 7
          }
        },
        line: 81
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 111,
            column: 17
          },
          end: {
            line: 111,
            column: 18
          }
        },
        loc: {
          start: {
            line: 112,
            column: 10
          },
          end: {
            line: 115,
            column: 25
          }
        },
        line: 112
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 125,
            column: 13
          },
          end: {
            line: 125,
            column: 14
          }
        },
        loc: {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 127,
            column: 28
          }
        },
        line: 126
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 130,
            column: 26
          },
          end: {
            line: 130,
            column: 27
          }
        },
        loc: {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 133,
            column: 21
          }
        },
        line: 131
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 134,
            column: 15
          },
          end: {
            line: 134,
            column: 16
          }
        },
        loc: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 73
          }
        },
        line: 134
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 138,
            column: 17
          },
          end: {
            line: 138,
            column: 18
          }
        },
        loc: {
          start: {
            line: 138,
            column: 27
          },
          end: {
            line: 138,
            column: 75
          }
        },
        line: 138
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 166,
            column: 6
          },
          end: {
            line: 166,
            column: 7
          }
        },
        loc: {
          start: {
            line: 166,
            column: 15
          },
          end: {
            line: 168,
            column: 5
          }
        },
        line: 166
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 180,
            column: 28
          },
          end: {
            line: 180,
            column: 29
          }
        },
        loc: {
          start: {
            line: 180,
            column: 37
          },
          end: {
            line: 180,
            column: 86
          }
        },
        line: 180
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 226,
            column: 26
          },
          end: {
            line: 226,
            column: 27
          }
        },
        loc: {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 227,
            column: 92
          }
        },
        line: 227
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 228,
            column: 15
          },
          end: {
            line: 228,
            column: 16
          }
        },
        loc: {
          start: {
            line: 229,
            column: 8
          },
          end: {
            line: 229,
            column: 94
          }
        },
        line: 229
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 295,
            column: 4
          },
          end: {
            line: 295,
            column: 5
          }
        },
        loc: {
          start: {
            line: 295,
            column: 13
          },
          end: {
            line: 295,
            column: 61
          }
        },
        line: 295
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 299,
            column: 13
          },
          end: {
            line: 299,
            column: 14
          }
        },
        loc: {
          start: {
            line: 300,
            column: 4
          },
          end: {
            line: 300,
            column: 90
          }
        },
        line: 300
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 305,
            column: 13
          },
          end: {
            line: 305,
            column: 14
          }
        },
        loc: {
          start: {
            line: 305,
            column: 22
          },
          end: {
            line: 305,
            column: 33
          }
        },
        line: 305
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 324,
            column: 2
          },
          end: {
            line: 324,
            column: 3
          }
        },
        loc: {
          start: {
            line: 324,
            column: 48
          },
          end: {
            line: 332,
            column: 3
          }
        },
        line: 324
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 334,
            column: 2
          },
          end: {
            line: 334,
            column: 3
          }
        },
        loc: {
          start: {
            line: 334,
            column: 21
          },
          end: {
            line: 341,
            column: 3
          }
        },
        line: 334
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 343,
            column: 2
          },
          end: {
            line: 343,
            column: 3
          }
        },
        loc: {
          start: {
            line: 343,
            column: 22
          },
          end: {
            line: 346,
            column: 3
          }
        },
        line: 343
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 348,
            column: 2
          },
          end: {
            line: 348,
            column: 3
          }
        },
        loc: {
          start: {
            line: 348,
            column: 25
          },
          end: {
            line: 350,
            column: 3
          }
        },
        line: 348
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 352,
            column: 2
          },
          end: {
            line: 352,
            column: 3
          }
        },
        loc: {
          start: {
            line: 352,
            column: 13
          },
          end: {
            line: 357,
            column: 3
          }
        },
        line: 352
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 362,
            column: 15
          },
          end: {
            line: 362,
            column: 16
          }
        },
        loc: {
          start: {
            line: 362,
            column: 31
          },
          end: {
            line: 362,
            column: 93
          }
        },
        line: 362
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 362,
            column: 45
          },
          end: {
            line: 362,
            column: 46
          }
        },
        loc: {
          start: {
            line: 362,
            column: 58
          },
          end: {
            line: 362,
            column: 92
          }
        },
        line: 362
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 364,
            column: 2
          },
          end: {
            line: 364,
            column: 3
          }
        },
        loc: {
          start: {
            line: 364,
            column: 32
          },
          end: {
            line: 373,
            column: 3
          }
        },
        line: 364
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 375,
            column: 2
          },
          end: {
            line: 375,
            column: 3
          }
        },
        loc: {
          start: {
            line: 375,
            column: 11
          },
          end: {
            line: 382,
            column: 3
          }
        },
        line: 375
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 384,
            column: 2
          },
          end: {
            line: 384,
            column: 3
          }
        },
        loc: {
          start: {
            line: 384,
            column: 34
          },
          end: {
            line: 388,
            column: 3
          }
        },
        line: 384
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 393,
            column: 16
          },
          end: {
            line: 393,
            column: 17
          }
        },
        loc: {
          start: {
            line: 393,
            column: 23
          },
          end: {
            line: 397,
            column: 3
          }
        },
        line: 393
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 393,
            column: 23
          },
          end: {
            line: 393,
            column: 24
          }
        },
        loc: {
          start: {
            line: 393,
            column: 29
          },
          end: {
            line: 397,
            column: 3
          }
        },
        line: 393
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 399,
            column: 2
          },
          end: {
            line: 399,
            column: 3
          }
        },
        loc: {
          start: {
            line: 399,
            column: 11
          },
          end: {
            line: 564,
            column: 3
          }
        },
        line: 399
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 403,
            column: 32
          },
          end: {
            line: 403,
            column: 33
          }
        },
        loc: {
          start: {
            line: 403,
            column: 38
          },
          end: {
            line: 408,
            column: 5
          }
        },
        line: 403
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 435,
            column: 27
          },
          end: {
            line: 435,
            column: 28
          }
        },
        loc: {
          start: {
            line: 435,
            column: 35
          },
          end: {
            line: 440,
            column: 5
          }
        },
        line: 435
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 455,
            column: 23
          },
          end: {
            line: 455,
            column: 24
          }
        },
        loc: {
          start: {
            line: 455,
            column: 29
          },
          end: {
            line: 455,
            column: 59
          }
        },
        line: 455
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 468,
            column: 23
          },
          end: {
            line: 468,
            column: 24
          }
        },
        loc: {
          start: {
            line: 468,
            column: 29
          },
          end: {
            line: 468,
            column: 58
          }
        },
        line: 468
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 475,
            column: 23
          },
          end: {
            line: 475,
            column: 24
          }
        },
        loc: {
          start: {
            line: 476,
            column: 12
          },
          end: {
            line: 478,
            column: 29
          }
        },
        line: 476
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 482,
            column: 18
          },
          end: {
            line: 482,
            column: 19
          }
        },
        loc: {
          start: {
            line: 483,
            column: 10
          },
          end: {
            line: 560,
            column: 21
          }
        },
        line: 483
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 485,
            column: 21
          },
          end: {
            line: 485,
            column: 22
          }
        },
        loc: {
          start: {
            line: 485,
            column: 28
          },
          end: {
            line: 559,
            column: 13
          }
        },
        line: 485
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 548,
            column: 71
          },
          end: {
            line: 548,
            column: 72
          }
        },
        loc: {
          start: {
            line: 548,
            column: 77
          },
          end: {
            line: 548,
            column: 79
          }
        },
        line: 548
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 19
          }
        }, {
          start: {
            line: 36,
            column: 23
          },
          end: {
            line: 36,
            column: 43
          }
        }, {
          start: {
            line: 36,
            column: 47
          },
          end: {
            line: 36,
            column: 87
          }
        }],
        line: 36
      },
      "1": {
        loc: {
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 8
          },
          end: {
            line: 38,
            column: 19
          }
        }, {
          start: {
            line: 38,
            column: 23
          },
          end: {
            line: 38,
            column: 43
          }
        }, {
          start: {
            line: 38,
            column: 47
          },
          end: {
            line: 38,
            column: 89
          }
        }],
        line: 38
      },
      "2": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 19
          }
        }, {
          start: {
            line: 61,
            column: 23
          },
          end: {
            line: 61,
            column: 43
          }
        }, {
          start: {
            line: 61,
            column: 47
          },
          end: {
            line: 61,
            column: 92
          }
        }],
        line: 61
      },
      "3": {
        loc: {
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 84,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 8
          },
          end: {
            line: 84,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "4": {
        loc: {
          start: {
            line: 112,
            column: 10
          },
          end: {
            line: 115,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 11
          },
          end: {
            line: 112,
            column: 22
          }
        }, {
          start: {
            line: 113,
            column: 12
          },
          end: {
            line: 113,
            column: 32
          }
        }, {
          start: {
            line: 114,
            column: 12
          },
          end: {
            line: 114,
            column: 64
          }
        }, {
          start: {
            line: 115,
            column: 10
          },
          end: {
            line: 115,
            column: 25
          }
        }],
        line: 112
      },
      "5": {
        loc: {
          start: {
            line: 126,
            column: 6
          },
          end: {
            line: 127,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 7
          },
          end: {
            line: 126,
            column: 18
          }
        }, {
          start: {
            line: 126,
            column: 22
          },
          end: {
            line: 126,
            column: 42
          }
        }, {
          start: {
            line: 126,
            column: 46
          },
          end: {
            line: 126,
            column: 83
          }
        }, {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 127,
            column: 28
          }
        }],
        line: 126
      },
      "6": {
        loc: {
          start: {
            line: 131,
            column: 8
          },
          end: {
            line: 133,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 131,
            column: 20
          }
        }, {
          start: {
            line: 131,
            column: 24
          },
          end: {
            line: 131,
            column: 44
          }
        }, {
          start: {
            line: 131,
            column: 48
          },
          end: {
            line: 131,
            column: 85
          }
        }, {
          start: {
            line: 132,
            column: 8
          },
          end: {
            line: 132,
            column: 30
          }
        }, {
          start: {
            line: 133,
            column: 8
          },
          end: {
            line: 133,
            column: 21
          }
        }],
        line: 131
      },
      "7": {
        loc: {
          start: {
            line: 134,
            column: 25
          },
          end: {
            line: 134,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 134,
            column: 43
          },
          end: {
            line: 134,
            column: 61
          }
        }, {
          start: {
            line: 134,
            column: 64
          },
          end: {
            line: 134,
            column: 73
          }
        }],
        line: 134
      },
      "8": {
        loc: {
          start: {
            line: 138,
            column: 27
          },
          end: {
            line: 138,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 45
          },
          end: {
            line: 138,
            column: 63
          }
        }, {
          start: {
            line: 138,
            column: 66
          },
          end: {
            line: 138,
            column: 75
          }
        }],
        line: 138
      },
      "9": {
        loc: {
          start: {
            line: 166,
            column: 15
          },
          end: {
            line: 168,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 166,
            column: 15
          },
          end: {
            line: 166,
            column: 28
          }
        }, {
          start: {
            line: 166,
            column: 32
          },
          end: {
            line: 168,
            column: 5
          }
        }],
        line: 166
      },
      "10": {
        loc: {
          start: {
            line: 180,
            column: 37
          },
          end: {
            line: 180,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 180,
            column: 51
          },
          end: {
            line: 180,
            column: 62
          }
        }, {
          start: {
            line: 180,
            column: 65
          },
          end: {
            line: 180,
            column: 86
          }
        }],
        line: 180
      },
      "11": {
        loc: {
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 227,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 8
          },
          end: {
            line: 227,
            column: 19
          }
        }, {
          start: {
            line: 227,
            column: 23
          },
          end: {
            line: 227,
            column: 43
          }
        }, {
          start: {
            line: 227,
            column: 47
          },
          end: {
            line: 227,
            column: 92
          }
        }],
        line: 227
      },
      "12": {
        loc: {
          start: {
            line: 229,
            column: 8
          },
          end: {
            line: 229,
            column: 94
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 229,
            column: 8
          },
          end: {
            line: 229,
            column: 19
          }
        }, {
          start: {
            line: 229,
            column: 23
          },
          end: {
            line: 229,
            column: 43
          }
        }, {
          start: {
            line: 229,
            column: 47
          },
          end: {
            line: 229,
            column: 94
          }
        }],
        line: 229
      },
      "13": {
        loc: {
          start: {
            line: 295,
            column: 13
          },
          end: {
            line: 295,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 295,
            column: 13
          },
          end: {
            line: 295,
            column: 27
          }
        }, {
          start: {
            line: 295,
            column: 31
          },
          end: {
            line: 295,
            column: 61
          }
        }],
        line: 295
      },
      "14": {
        loc: {
          start: {
            line: 300,
            column: 4
          },
          end: {
            line: 300,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 300,
            column: 4
          },
          end: {
            line: 300,
            column: 15
          }
        }, {
          start: {
            line: 300,
            column: 19
          },
          end: {
            line: 300,
            column: 39
          }
        }, {
          start: {
            line: 300,
            column: 43
          },
          end: {
            line: 300,
            column: 90
          }
        }],
        line: 300
      },
      "15": {
        loc: {
          start: {
            line: 325,
            column: 4
          },
          end: {
            line: 330,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 325,
            column: 4
          },
          end: {
            line: 330,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 325
      },
      "16": {
        loc: {
          start: {
            line: 325,
            column: 8
          },
          end: {
            line: 325,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 325,
            column: 8
          },
          end: {
            line: 325,
            column: 27
          }
        }, {
          start: {
            line: 325,
            column: 31
          },
          end: {
            line: 325,
            column: 42
          }
        }],
        line: 325
      },
      "17": {
        loc: {
          start: {
            line: 353,
            column: 4
          },
          end: {
            line: 355,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 353,
            column: 4
          },
          end: {
            line: 355,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 353
      },
      "18": {
        loc: {
          start: {
            line: 366,
            column: 4
          },
          end: {
            line: 372,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 366,
            column: 4
          },
          end: {
            line: 372,
            column: 5
          }
        }, {
          start: {
            line: 368,
            column: 11
          },
          end: {
            line: 372,
            column: 5
          }
        }],
        line: 366
      },
      "19": {
        loc: {
          start: {
            line: 377,
            column: 4
          },
          end: {
            line: 381,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 377,
            column: 4
          },
          end: {
            line: 381,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 377
      },
      "20": {
        loc: {
          start: {
            line: 387,
            column: 11
          },
          end: {
            line: 387,
            column: 96
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 12
          },
          end: {
            line: 387,
            column: 37
          }
        }, {
          start: {
            line: 387,
            column: 41
          },
          end: {
            line: 387,
            column: 61
          }
        }, {
          start: {
            line: 387,
            column: 66
          },
          end: {
            line: 387,
            column: 96
          }
        }],
        line: 387
      },
      "21": {
        loc: {
          start: {
            line: 394,
            column: 4
          },
          end: {
            line: 396,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 394,
            column: 4
          },
          end: {
            line: 396,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 394
      },
      "22": {
        loc: {
          start: {
            line: 400,
            column: 26
          },
          end: {
            line: 400,
            column: 68
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 400,
            column: 41
          },
          end: {
            line: 400,
            column: 68
          }
        }],
        line: 400
      },
      "23": {
        loc: {
          start: {
            line: 404,
            column: 6
          },
          end: {
            line: 406,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 404,
            column: 6
          },
          end: {
            line: 406,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 404
      },
      "24": {
        loc: {
          start: {
            line: 414,
            column: 4
          },
          end: {
            line: 429,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 414,
            column: 4
          },
          end: {
            line: 429,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 414
      },
      "25": {
        loc: {
          start: {
            line: 422,
            column: 8
          },
          end: {
            line: 424,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 422,
            column: 8
          },
          end: {
            line: 422,
            column: 35
          }
        }, {
          start: {
            line: 423,
            column: 8
          },
          end: {
            line: 423,
            column: 27
          }
        }, {
          start: {
            line: 424,
            column: 8
          },
          end: {
            line: 424,
            column: 52
          }
        }],
        line: 422
      },
      "26": {
        loc: {
          start: {
            line: 426,
            column: 8
          },
          end: {
            line: 428,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 426,
            column: 8
          },
          end: {
            line: 426,
            column: 34
          }
        }, {
          start: {
            line: 427,
            column: 8
          },
          end: {
            line: 427,
            column: 26
          }
        }, {
          start: {
            line: 428,
            column: 8
          },
          end: {
            line: 428,
            column: 61
          }
        }],
        line: 426
      },
      "27": {
        loc: {
          start: {
            line: 436,
            column: 6
          },
          end: {
            line: 438,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 436,
            column: 6
          },
          end: {
            line: 438,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 436
      },
      "28": {
        loc: {
          start: {
            line: 442,
            column: 21
          },
          end: {
            line: 442,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 442,
            column: 46
          },
          end: {
            line: 442,
            column: 48
          }
        }, {
          start: {
            line: 442,
            column: 51
          },
          end: {
            line: 442,
            column: 60
          }
        }],
        line: 442
      },
      "29": {
        loc: {
          start: {
            line: 451,
            column: 32
          },
          end: {
            line: 451,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 451,
            column: 77
          },
          end: {
            line: 451,
            column: 83
          }
        }, {
          start: {
            line: 451,
            column: 86
          },
          end: {
            line: 451,
            column: 88
          }
        }],
        line: 451
      },
      "30": {
        loc: {
          start: {
            line: 451,
            column: 32
          },
          end: {
            line: 451,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 451,
            column: 32
          },
          end: {
            line: 451,
            column: 55
          }
        }, {
          start: {
            line: 451,
            column: 59
          },
          end: {
            line: 451,
            column: 74
          }
        }],
        line: 451
      },
      "31": {
        loc: {
          start: {
            line: 452,
            column: 24
          },
          end: {
            line: 452,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 452,
            column: 24
          },
          end: {
            line: 452,
            column: 46
          }
        }, {
          start: {
            line: 452,
            column: 50
          },
          end: {
            line: 452,
            column: 65
          }
        }],
        line: 452
      },
      "32": {
        loc: {
          start: {
            line: 465,
            column: 32
          },
          end: {
            line: 465,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 465,
            column: 49
          },
          end: {
            line: 465,
            column: 55
          }
        }, {
          start: {
            line: 465,
            column: 58
          },
          end: {
            line: 465,
            column: 60
          }
        }],
        line: 465
      },
      "33": {
        loc: {
          start: {
            line: 489,
            column: 16
          },
          end: {
            line: 489,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 489,
            column: 16
          },
          end: {
            line: 489,
            column: 50
          }
        }, {
          start: {
            line: 489,
            column: 54
          },
          end: {
            line: 489,
            column: 98
          }
        }],
        line: 489
      },
      "34": {
        loc: {
          start: {
            line: 494,
            column: 41
          },
          end: {
            line: 494,
            column: 53
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 494,
            column: 51
          },
          end: {
            line: 494,
            column: 53
          }
        }],
        line: 494
      },
      "35": {
        loc: {
          start: {
            line: 494,
            column: 64
          },
          end: {
            line: 494,
            column: 77
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 494,
            column: 64
          },
          end: {
            line: 494,
            column: 71
          }
        }, {
          start: {
            line: 494,
            column: 75
          },
          end: {
            line: 494,
            column: 77
          }
        }],
        line: 494
      },
      "36": {
        loc: {
          start: {
            line: 500,
            column: 31
          },
          end: {
            line: 515,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 500,
            column: 31
          },
          end: {
            line: 500,
            column: 38
          }
        }, {
          start: {
            line: 501,
            column: 16
          },
          end: {
            line: 514,
            column: 29
          }
        }],
        line: 500
      },
      "37": {
        loc: {
          start: {
            line: 504,
            column: 21
          },
          end: {
            line: 511,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 504,
            column: 21
          },
          end: {
            line: 504,
            column: 43
          }
        }, {
          start: {
            line: 505,
            column: 22
          },
          end: {
            line: 505,
            column: 31
          }
        }, {
          start: {
            line: 506,
            column: 24
          },
          end: {
            line: 510,
            column: 26
          }
        }],
        line: 504
      },
      "38": {
        loc: {
          start: {
            line: 516,
            column: 14
          },
          end: {
            line: 532,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 516,
            column: 14
          },
          end: {
            line: 532,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 516
      },
      "39": {
        loc: {
          start: {
            line: 517,
            column: 16
          },
          end: {
            line: 531,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 517,
            column: 16
          },
          end: {
            line: 531,
            column: 17
          }
        }, {
          start: {
            line: 525,
            column: 23
          },
          end: {
            line: 531,
            column: 17
          }
        }],
        line: 517
      },
      "40": {
        loc: {
          start: {
            line: 520,
            column: 36
          },
          end: {
            line: 520,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 520,
            column: 36
          },
          end: {
            line: 520,
            column: 50
          }
        }, {
          start: {
            line: 520,
            column: 54
          },
          end: {
            line: 520,
            column: 82
          }
        }],
        line: 520
      },
      "41": {
        loc: {
          start: {
            line: 525,
            column: 23
          },
          end: {
            line: 531,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 525,
            column: 23
          },
          end: {
            line: 531,
            column: 17
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 525
      },
      "42": {
        loc: {
          start: {
            line: 525,
            column: 27
          },
          end: {
            line: 525,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 525,
            column: 27
          },
          end: {
            line: 525,
            column: 33
          }
        }, {
          start: {
            line: 525,
            column: 37
          },
          end: {
            line: 525,
            column: 44
          }
        }],
        line: 525
      },
      "43": {
        loc: {
          start: {
            line: 534,
            column: 14
          },
          end: {
            line: 536,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 534,
            column: 14
          },
          end: {
            line: 536,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 534
      },
      "44": {
        loc: {
          start: {
            line: 534,
            column: 18
          },
          end: {
            line: 534,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 534,
            column: 18
          },
          end: {
            line: 534,
            column: 39
          }
        }, {
          start: {
            line: 534,
            column: 43
          },
          end: {
            line: 534,
            column: 52
          }
        }],
        line: 534
      },
      "45": {
        loc: {
          start: {
            line: 537,
            column: 14
          },
          end: {
            line: 539,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 537,
            column: 14
          },
          end: {
            line: 539,
            column: 15
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 537
      },
      "46": {
        loc: {
          start: {
            line: 543,
            column: 19
          },
          end: {
            line: 555,
            column: 19
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 544,
            column: 20
          },
          end: {
            line: 550,
            column: 30
          }
        }, {
          start: {
            line: 552,
            column: 20
          },
          end: {
            line: 554,
            column: 30
          }
        }],
        line: 543
      },
      "47": {
        loc: {
          start: {
            line: 548,
            column: 31
          },
          end: {
            line: 548,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 548,
            column: 43
          },
          end: {
            line: 548,
            column: 68
          }
        }, {
          start: {
            line: 548,
            column: 71
          },
          end: {
            line: 548,
            column: 79
          }
        }],
        line: 548
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0],
      "5": [0, 0, 0, 0],
      "6": [0, 0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0],
      "26": [0, 0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e9b682b705c3af8b7a7f745a78cd754f4b113bb4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2r8wniypo = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2r8wniypo();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _ref = (cov_2r8wniypo().s[0]++, _stylingConstants.default),
  color = _ref.color,
  spacing = _ref.spacing,
  font = _ref.font;
var Wrapper = (cov_2r8wniypo().s[1]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-mini-calendar"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      width: 20rem;\n      background-color: ", ";\n      color: ", ";\n      padding-bottom: ", ";\n    "])), function (props) {
  cov_2r8wniypo().f[0]++;
  cov_2r8wniypo().s[2]++;
  return (cov_2r8wniypo().b[0][0]++, props.theme) && (cov_2r8wniypo().b[0][1]++, props.theme.calendar) && (cov_2r8wniypo().b[0][2]++, props.theme.calendar.miniCalendarBgColor);
}, function (props) {
  cov_2r8wniypo().f[1]++;
  cov_2r8wniypo().s[3]++;
  return (cov_2r8wniypo().b[1][0]++, props.theme) && (cov_2r8wniypo().b[1][1]++, props.theme.calendar) && (cov_2r8wniypo().b[1][2]++, props.theme.calendar.miniCalendarTextColor);
}, spacing.xsmall)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n    "])), _themeMapper.evolutionTheme.calendar.miniCalendar.width))));

// put border on the top left for the containder and for object inside
var FlexWeek = (cov_2r8wniypo().s[4]++, (0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: 'g-mini-calendar-week'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)([""]))));
var WeekDayWrapper = (cov_2r8wniypo().s[5]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "g-mini-calendar-weekDay"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: center;\n      padding: ", " 0 ", " 0;\n      color: ", ";\n      font-size: ", ";\n      justify-content: space-around;\n      font-weight: ", ";\n    "])), spacing.small, spacing.xsmall, function (props) {
  cov_2r8wniypo().f[2]++;
  cov_2r8wniypo().s[6]++;
  return (cov_2r8wniypo().b[2][0]++, props.theme) && (cov_2r8wniypo().b[2][1]++, props.theme.calendar) && (cov_2r8wniypo().b[2][2]++, props.theme.calendar.miniCalendarDayTextColor);
}, font.sizeS, font.weightBold)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n      text-align: center;\n      justify-content: space-around;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: ", ";\n      padding: ", ";\n    "])), _themeMapper.evolutionTheme.calendar.miniCalendar.weekday.fontSize, _themeMapper.evolutionTheme.calendar.miniCalendar.weekday.lineHeight, _themeMapper.evolutionTheme.calendar.miniCalendar.weekday.fontWeight, _themeMapper.evolutionTheme.calendar.miniCalendar.weekday.color, _themeMapper.evolutionTheme.calendar.miniCalendar.weekday.padding))));
// Use a specific component to return the text without poluting the main component with injectIntl
var WeekDay = (cov_2r8wniypo().s[7]++, (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _reactIntl.injectIntl)(function (_ref2) {
  var intl = _ref2.intl,
    date = _ref2.date,
    themeQueries = _ref2.themeQueries;
  cov_2r8wniypo().f[3]++;
  var numberCharacterOfDay = (cov_2r8wniypo().s[8]++, function () {
    cov_2r8wniypo().f[4]++;
    cov_2r8wniypo().s[9]++;
    if (themeQueries.EVOLUTION) {
      cov_2r8wniypo().b[3][0]++;
      cov_2r8wniypo().s[10]++;
      return 3;
    } else {
      cov_2r8wniypo().b[3][1]++;
    }
    cov_2r8wniypo().s[11]++;
    return 2;
  }());
  var dayText = (cov_2r8wniypo().s[12]++, intl.formatDate(date, {
    weekday: 'short'
  }).substring(0, numberCharacterOfDay));
  cov_2r8wniypo().s[13]++;
  return dayText;
}))));
var MiniDay = (cov_2r8wniypo().s[14]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n    text-align: center;\n    text-transform: capitalize;\n    margin: 0 auto 0 auto;\n    font-size: 0.8rem;\n    height: 2.25rem;\n    font-weight: ", ";\n\n    &.g-mini-calendar-datepicker-day {\n      cursor: pointer;\n\n      .g-mini-calendar-day-number > span {\n        color: ", ";\n      }\n      &.selectedDay {\n        background-color: ", ";\n        .g-mini-calendar-day-number > span {\n          color: white;\n        }\n      }\n    }\n\n    color: ", ";\n    &.selectedDay,\n    &:hover {\n      background-color: ", ";\n      color: ", ";\n      cursor: pointer;\n      /* force the color of a class, any component that want to adapt should pass this class to the content element */\n      .g-mini-calendar-content {\n        color: ", ";\n      }\n    }\n  "])), font.weightBold, function (props) {
  cov_2r8wniypo().f[5]++;
  cov_2r8wniypo().s[15]++;
  return (cov_2r8wniypo().b[4][0]++, props.theme) && (cov_2r8wniypo().b[4][1]++, props.theme.calendar) && (cov_2r8wniypo().b[4][2]++, props.theme.calendar.miniCalencarDatePickerTextColor) || (cov_2r8wniypo().b[4][3]++, color.textColor);
}, color.boxBackground, function (props) {
  cov_2r8wniypo().f[6]++;
  cov_2r8wniypo().s[16]++;
  return (cov_2r8wniypo().b[5][0]++, props.theme) && (cov_2r8wniypo().b[5][1]++, props.theme.calendar) && (cov_2r8wniypo().b[5][2]++, props.theme.calendar[props.indicator]) || (cov_2r8wniypo().b[5][3]++, color[props.indicator]);
}, function (props) {
  cov_2r8wniypo().f[7]++;
  cov_2r8wniypo().s[17]++;
  return (cov_2r8wniypo().b[6][0]++, props.theme) && (cov_2r8wniypo().b[6][1]++, props.theme.calendar) && (cov_2r8wniypo().b[6][2]++, props.theme.calendar[props.indicator]) || (cov_2r8wniypo().b[6][3]++, color[props.indicator]) || (cov_2r8wniypo().b[6][4]++, 'transparent');
}, function (props) {
  cov_2r8wniypo().f[8]++;
  cov_2r8wniypo().s[18]++;
  return props.indicator ? (cov_2r8wniypo().b[7][0]++, 'white !important') : (cov_2r8wniypo().b[7][1]++, 'inherit');
}, function (props) {
  cov_2r8wniypo().f[9]++;
  cov_2r8wniypo().s[19]++;
  return props.indicator ? (cov_2r8wniypo().b[8][0]++, 'white !important') : (cov_2r8wniypo().b[8][1]++, 'inherit');
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n    width: 34px;\n    height: 34px;\n    margin: 0;\n    padding: 6px 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    text-transform: capitalize;\n    font-size: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    border-radius: 9999px;\n\n    .g-mini-calendar-day-number {\n      padding: 0;\n      &:has(.stx-legendIndicator-availability) {\n        padding-top: 14.5px;\n      }\n      .stx-mini-day-in-same-month > span {\n        color: var(--textColor);\n      }\n    }\n    ", "\n\n    &.g-mini-calendar-datepicker-day {\n      cursor: pointer;\n\n      .g-mini-calendar-day-number {\n        > span {\n          color: var(--textColor);\n        }\n      }\n\n      &.selectedDay {\n        background-color: ", ";\n        width: 34px;\n        height: 34px;\n        margin-top: 1px;\n        .g-mini-calendar-day-number {\n          > span {\n            color: var(--primaryTextColor);\n          }\n        }\n      }\n    }\n  "])), _themeMapper.evolutionTheme.typography.body2.fontSize, _themeMapper.evolutionTheme.typography.body2.lineHeight, _themeMapper.evolutionTheme.fontWeight.medium, function (props) {
  cov_2r8wniypo().f[10]++;
  cov_2r8wniypo().s[20]++;
  return (cov_2r8wniypo().b[9][0]++, props.isToday) && (cov_2r8wniypo().b[9][1]++, "\n      background-color: var(--itemRowBgColor);\n    ");
}, function (props) {
  cov_2r8wniypo().f[11]++;
  cov_2r8wniypo().s[21]++;
  return props.color ? (cov_2r8wniypo().b[10][0]++, props.color) : (cov_2r8wniypo().b[10][1]++, 'var(--primaryColor)');
}))));
var MiniDayWrapper = (cov_2r8wniypo().s[22]++, (0, _styledComponents.default)(_gridStyled.Box)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"]))));
var DayNumber = (cov_2r8wniypo().s[23]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: "g-mini-calendar-day-number"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      line-height: 0.8rem;\n      padding-top: 0.725rem;\n    "])))), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      line-height: 20px;\n      padding-top: 0.725rem;\n    "]))))));
var MonthWrapper = (cov_2r8wniypo().s[24]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Flex).attrs({
  className: "g-mini-calendar-month-selector"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      justify-content: space-between;\n      background-color: ", ";\n      color: ", ";\n      min-height: ", ";\n      padding: ", " 0 ", " 0;\n    "])), function (props) {
  cov_2r8wniypo().f[12]++;
  cov_2r8wniypo().s[25]++;
  return (cov_2r8wniypo().b[11][0]++, props.theme) && (cov_2r8wniypo().b[11][1]++, props.theme.calendar) && (cov_2r8wniypo().b[11][2]++, props.theme.calendar.miniCalendarMonthBgColor);
}, function (props) {
  cov_2r8wniypo().f[13]++;
  cov_2r8wniypo().s[26]++;
  return (cov_2r8wniypo().b[12][0]++, props.theme) && (cov_2r8wniypo().b[12][1]++, props.theme.calendar) && (cov_2r8wniypo().b[12][2]++, props.theme.calendar.miniCalendarMonthTextColor);
}, font.sizeXxl, spacing.xsmall, spacing.xsmall)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      justify-content: space-between;\n      min-height: ", ";\n      padding: ", ";\n      color: ", ";\n    "])), _themeMapper.evolutionTheme.calendar.miniCalendar.monthSelector.height, _themeMapper.evolutionTheme.calendar.miniCalendar.monthSelector.padding, _themeMapper.evolutionTheme.calendar.miniCalendar.monthSelector.color))));
var ChevronWrapper = (cov_2r8wniypo().s[27]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "g-mini-calendar-chevron-wrapper"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n    "])), font.sizeXxxl)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n      width: ", ";\n      > .g-Button {\n        width: ", ";\n        height: ", ";\n        border-radius: 50%;\n        > .g-Icon {\n          color: var(--secondaryTextColor);\n        }\n      }\n    "])), font.sizeXxxl, _themeMapper.evolutionTheme.calendar.miniCalendar.monthSelector.height, _themeMapper.evolutionTheme.calendar.miniCalendar.monthSelector.height))));
var MonthName = (cov_2r8wniypo().s[28]++, (0, _utils.withThemedStyles)((0, _styledComponents.default)(_gridStyled.Box).attrs({
  className: "g-mini-calendar-month-name"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n      align-self: center;\n      height: ", ";\n    "])), font.sizeL)), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n      align-self: center;\n      font-size: ", ";\n      line-height: ", ";\n      font-weight: ", ";\n      color: var(--textColor);\n    "])), _themeMapper.evolutionTheme.typography.body1.fontSize, _themeMapper.evolutionTheme.typography.body1.lineHeight, _themeMapper.evolutionTheme.fontWeight.bold))));
var A = (cov_2r8wniypo().s[29]++, _styledComponents.default.a(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n  text-decoration: none;\n  color: inherit;\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n"]))));
var DayContent = (cov_2r8wniypo().s[30]++, (0, _styledComponents.default)(_gridStyled.Flex)(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n  flex-direction: column;\n  width: ", ";\n  ", ";\n"])), font.sizeXxxl, function (props) {
  cov_2r8wniypo().f[14]++;
  cov_2r8wniypo().s[31]++;
  return (cov_2r8wniypo().b[13][0]++, !props.daydata) && (cov_2r8wniypo().b[13][1]++, "color:".concat(color.disabledText, ";"));
}));
var Chevron = (cov_2r8wniypo().s[32]++, (0, _styledComponents.default)(_icon.default).attrs({
  iconColor: function iconColor(props) {
    cov_2r8wniypo().f[15]++;
    cov_2r8wniypo().s[33]++;
    return (cov_2r8wniypo().b[14][0]++, props.theme) && (cov_2r8wniypo().b[14][1]++, props.theme.calendar) && (cov_2r8wniypo().b[14][2]++, props.theme.calendar.miniCalendarMonthTextColor);
  }
})(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)([""]))));
var LegendIndicator = (cov_2r8wniypo().s[34]++, (0, _styledComponents.default)(_icon.default)(_templateObject20 || (_templateObject20 = (0, _taggedTemplateLiteral2.default)(["\n  &.stx-legendIndicator-availability.stx-legendIndicator-icon {\n    color: ", ";\n    display: grid;\n    border-radius: 50%;\n    right: -15px;\n    top: -29px;\n    position: relative;\n    svg {\n      width: 8px;\n      height: 8px\n    }\n  }\n"])), function (props) {
  cov_2r8wniypo().f[16]++;
  cov_2r8wniypo().s[35]++;
  return props.color;
}));

/**
 * Calendar component that displays a grid of days in 7 columns
 * On mobile phone, show a list of days in one column
 *
 */
var MiniCalendar = /*#__PURE__*/function (_React$Component) {
  function MiniCalendar(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MiniCalendar);
    cov_2r8wniypo().f[18]++;
    cov_2r8wniypo().s[39]++;
    _this = _callSuper(this, MiniCalendar, [props]);
    /**
     * Method to merge the partial state we pass as parameter
     */
    (0, _defineProperty2.default)(_this, "mergeState", (cov_2r8wniypo().s[48]++, function (partialState) {
      cov_2r8wniypo().f[22]++;
      cov_2r8wniypo().s[49]++;
      return _this.setState(function (prevState) {
        cov_2r8wniypo().f[23]++;
        cov_2r8wniypo().s[50]++;
        return (0, _lodash.merge)({}, prevState, partialState);
      });
    }));
    /**
     * Method to handle the click in the datepicker component
     */
    (0, _defineProperty2.default)(_this, "handleClick", (cov_2r8wniypo().s[60]++, function (day) {
      cov_2r8wniypo().f[27]++;
      cov_2r8wniypo().s[61]++;
      return function () {
        cov_2r8wniypo().f[28]++;
        cov_2r8wniypo().s[62]++;
        if (_this.props.onClick) {
          cov_2r8wniypo().b[21][0]++;
          cov_2r8wniypo().s[63]++;
          _this.props.onClick(day);
        } else {
          cov_2r8wniypo().b[21][1]++;
        }
      };
    }));
    cov_2r8wniypo().s[40]++;
    _this.state = {
      mobileView: false,
      month: props.month
    };
    cov_2r8wniypo().s[41]++;
    _this.changeMonth = _this.changeMonth.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(MiniCalendar, _React$Component);
  return (0, _createClass2.default)(MiniCalendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_2r8wniypo().f[19]++;
      cov_2r8wniypo().s[42]++;
      window.addEventListener('resize', this.update.bind(this));
      cov_2r8wniypo().s[43]++;
      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_2r8wniypo().f[20]++;
      cov_2r8wniypo().s[44]++;
      window.removeEventListener('resize', this.update.bind(this));
    }
  }, {
    key: "getMonth",
    value: function getMonth() {
      cov_2r8wniypo().f[21]++;
      cov_2r8wniypo().s[45]++;
      if (this.props.onMonthChange) {
        cov_2r8wniypo().b[17][0]++;
        cov_2r8wniypo().s[46]++;
        return this.props.month;
      } else {
        cov_2r8wniypo().b[17][1]++;
      }
      cov_2r8wniypo().s[47]++;
      return this.state.month;
    }
  }, {
    key: "changeMonth",
    value: function changeMonth(date, monthToAdd) {
      cov_2r8wniypo().f[24]++;
      var newDate = (cov_2r8wniypo().s[51]++, (0, _add_months.default)(date, monthToAdd));
      cov_2r8wniypo().s[52]++;
      if (this.props.onMonthChange) {
        cov_2r8wniypo().b[18][0]++;
        cov_2r8wniypo().s[53]++;
        this.props.onMonthChange(newDate);
      } else {
        cov_2r8wniypo().b[18][1]++;
        cov_2r8wniypo().s[54]++;
        this.setState({
          month: newDate
        });
      }
    }
  }, {
    key: "update",
    value: function update() {
      cov_2r8wniypo().f[25]++;
      var mobileView = (cov_2r8wniypo().s[55]++, window.innerWidth < 1024);
      cov_2r8wniypo().s[56]++;
      if (mobileView !== this.state.mobileView) {
        cov_2r8wniypo().b[19][0]++;
        cov_2r8wniypo().s[57]++;
        this.setState({
          mobileView: mobileView
        });
      } else {
        cov_2r8wniypo().b[19][1]++;
      }
    }
  }, {
    key: "isDayShouldDisabled",
    value: function isDayShouldDisabled(day, toDay) {
      cov_2r8wniypo().f[26]++;
      // sub 1 day to avoid disable this date
      var hideBeforeDate = (cov_2r8wniypo().s[58]++, (0, _sub_days.default)(this.props.hideBeforeDate, 1));
      cov_2r8wniypo().s[59]++;
      return (cov_2r8wniypo().b[20][0]++, !this.props.showPastDates) && (cov_2r8wniypo().b[20][1]++, (0, _is_before.default)(day, toDay)) || (cov_2r8wniypo().b[20][2]++, !(0, _is_before.default)(hideBeforeDate, day));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_2r8wniypo().f[29]++;
      var _ref3 = (cov_2r8wniypo().s[64]++, this.props),
        themeQueries = _ref3.themeQueries,
        _ref3$currentTheme = _ref3.currentTheme,
        currentTheme = _ref3$currentTheme === void 0 ? (cov_2r8wniypo().b[22][0]++, _themeProvider.TicketShopTheme.EQUILIBRIUM) : _ref3$currentTheme;
      var curMonth = (cov_2r8wniypo().s[65]++, this.getMonth());
      var weeks = (cov_2r8wniypo().s[66]++, (0, _utils2.getCalendarDaysByWeek)(curMonth));
      var monthButtonVariant = (cov_2r8wniypo().s[67]++, function () {
        cov_2r8wniypo().f[30]++;
        cov_2r8wniypo().s[68]++;
        if (themeQueries.EVOLUTION) {
          cov_2r8wniypo().b[23][0]++;
          cov_2r8wniypo().s[69]++;
          return _button.ButtonVariant.secondary;
        } else {
          cov_2r8wniypo().b[23][1]++;
        }
        cov_2r8wniypo().s[70]++;
        return undefined;
      }());
      var hasMonthBefore = (cov_2r8wniypo().s[71]++, true);
      var hasMonthAfter = (cov_2r8wniypo().s[72]++, true);

      // check if the date is in the rage and change if needed.
      cov_2r8wniypo().s[73]++;
      if (this.props.months) {
        cov_2r8wniypo().b[24][0]++;
        var years = (cov_2r8wniypo().s[74]++, (0, _keys.default)(this.props.months).sort());
        var firstYear = (cov_2r8wniypo().s[75]++, years[0]);
        var lastYear = (cov_2r8wniypo().s[76]++, years.pop());
        var curYear = (cov_2r8wniypo().s[77]++, (0, _get_year.default)(curMonth));
        var curMonthNb = (cov_2r8wniypo().s[78]++, (0, _get_month.default)(curMonth));
        cov_2r8wniypo().s[79]++;
        hasMonthBefore = (cov_2r8wniypo().b[25][0]++, this.props.forceBeforeMonth) || (cov_2r8wniypo().b[25][1]++, curYear > firstYear) || (cov_2r8wniypo().b[25][2]++, curMonthNb > this.props.months[firstYear][0]);
        cov_2r8wniypo().s[80]++;
        hasMonthAfter = (cov_2r8wniypo().b[26][0]++, this.props.forceAfterMonth) || (cov_2r8wniypo().b[26][1]++, curYear < lastYear) || (cov_2r8wniypo().b[26][2]++, curMonthNb < this.props.months[lastYear].slice(-1)[0]);
      } else {
        cov_2r8wniypo().b[24][1]++;
      }
      /**
       *
       * @param {"left" | "right"} side
       * @returns Icon's name
       */
      cov_2r8wniypo().s[81]++;
      var getChevronIcon = function getChevronIcon(side) {
        cov_2r8wniypo().f[31]++;
        cov_2r8wniypo().s[82]++;
        if (themeQueries.EVOLUTION) {
          cov_2r8wniypo().b[27][0]++;
          cov_2r8wniypo().s[83]++;
          return "riArrow".concat((0, _lodash.upperFirst)(side), "SLine");
        } else {
          cov_2r8wniypo().b[27][1]++;
        }
        cov_2r8wniypo().s[84]++;
        return "chevron-".concat(side);
      };
      var iconSize = (cov_2r8wniypo().s[85]++, themeQueries.EVOLUTION ? (cov_2r8wniypo().b[28][0]++, 20) : (cov_2r8wniypo().b[28][1]++, undefined));
      cov_2r8wniypo().s[86]++;
      return /*#__PURE__*/_react.default.createElement(Wrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 445,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(MonthWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 446,
          columnNumber: 9
        }
      }, /*#__PURE__*/_react.default.createElement(ChevronWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 447,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        variant: monthButtonVariant,
        style: {
          display: (cov_2r8wniypo().b[30][0]++, !themeQueries.EVOLUTION) && (cov_2r8wniypo().b[30][1]++, !hasMonthBefore) ? (cov_2r8wniypo().b[29][0]++, 'none') : (cov_2r8wniypo().b[29][1]++, '')
        },
        disabled: (cov_2r8wniypo().b[31][0]++, themeQueries.EVOLUTION) && (cov_2r8wniypo().b[31][1]++, !hasMonthBefore),
        small: true,
        flat: !themeQueries.EVOLUTION,
        onClick: function onClick() {
          cov_2r8wniypo().f[32]++;
          cov_2r8wniypo().s[87]++;
          return _this2.changeMonth(curMonth, -1);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 449,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(Chevron, {
        size: iconSize,
        iconName: getChevronIcon('left'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 456,
          columnNumber: 15
        }
      }))), /*#__PURE__*/_react.default.createElement(MonthName, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 459,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        value: curMonth,
        month: "long",
        year: "numeric",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 460,
          columnNumber: 13
        }
      })), /*#__PURE__*/_react.default.createElement(ChevronWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 462,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        variant: monthButtonVariant,
        style: {
          display: !hasMonthAfter ? (cov_2r8wniypo().b[32][0]++, 'none') : (cov_2r8wniypo().b[32][1]++, '')
        },
        small: true,
        flat: !themeQueries.EVOLUTION,
        onClick: function onClick() {
          cov_2r8wniypo().f[33]++;
          cov_2r8wniypo().s[88]++;
          return _this2.changeMonth(curMonth, 1);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 463,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(Chevron, {
        size: iconSize,
        iconName: getChevronIcon('right'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 469,
          columnNumber: 15
        }
      })))), /*#__PURE__*/_react.default.createElement(FlexWeek, {
        wrap: "wrap",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 473,
          columnNumber: 9
        }
      },
      // generate the name of the day (monday / tuesday / ..). Use week day number as key
      weeks[0].map(function (day) {
        cov_2r8wniypo().f[34]++;
        cov_2r8wniypo().s[89]++;
        return /*#__PURE__*/_react.default.createElement(WeekDayWrapper, {
          w: [1 / 7],
          key: (0, _get_day.default)(day),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 476,
            columnNumber: 13
          }
        }, /*#__PURE__*/_react.default.createElement(WeekDay, {
          date: day,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 477,
            columnNumber: 15
          }
        }));
      })),
      // for each week
      weeks.map(function (week) {
        cov_2r8wniypo().f[35]++;
        cov_2r8wniypo().s[90]++;
        return /*#__PURE__*/_react.default.createElement(FlexWeek, {
          wrap: "wrap",
          key: (0, _format.default)(week[0], 'YYYY-WW'),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 483,
            columnNumber: 11
          }
        },
        // for each day
        week.map(function (day) {
          cov_2r8wniypo().f[36]++;
          var dayText = (cov_2r8wniypo().s[91]++, (0, _format.default)(day, 'YYYY-MM-DD'));
          var toDay = (cov_2r8wniypo().s[92]++, (0, _start_of_day.default)(new Date()));
          var hidden = (cov_2r8wniypo().s[93]++, (cov_2r8wniypo().b[33][0]++, !(0, _is_same_month.default)(day, _this2.getMonth())) && (cov_2r8wniypo().b[33][1]++, currentTheme === _themeProvider.TicketShopTheme.EQUILIBRIUM));
          var isTheSameMonth = (cov_2r8wniypo().s[94]++, (0, _is_same_month.default)(day, _this2.getMonth()));
          var disabled = (cov_2r8wniypo().s[95]++, _this2.isDayShouldDisabled(day, toDay));
          var dayData = (cov_2r8wniypo().s[96]++, _this2.props.days[dayText]);
          // Indicator is the color to display, action is the link or function to call and content is additional image or object to show
          var _ref4 = (cov_2r8wniypo().s[97]++, (cov_2r8wniypo().b[35][0]++, dayData) || (cov_2r8wniypo().b[35][1]++, {})),
            indicator = _ref4.indicator,
            action = _ref4.action,
            _ref4$content = _ref4.content,
            content = _ref4$content === void 0 ? (cov_2r8wniypo().b[34][0]++, '') : _ref4$content,
            info = _ref4.info;
          var iconName = (cov_2r8wniypo().s[98]++, {
            NONE: 'prohibitedLine',
            LIMITED: 'circleLine',
            GOOD: 'circleFill'
          });
          var dayCalText = (cov_2r8wniypo().s[99]++, (cov_2r8wniypo().b[36][0]++, !hidden) && (cov_2r8wniypo().b[36][1]++, /*#__PURE__*/_react.default.createElement(DayContent, {
            title: info,
            daydata: dayData,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 501,
              columnNumber: 17
            }
          }, /*#__PURE__*/_react.default.createElement(DayNumber, {
            color: color[indicator],
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 502,
              columnNumber: 19
            }
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
            value: day,
            day: "numeric",
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 503,
              columnNumber: 21
            }
          }), (cov_2r8wniypo().b[37][0]++, themeQueries.EVOLUTION) && (cov_2r8wniypo().b[37][1]++, indicator) && (cov_2r8wniypo().b[37][2]++, /*#__PURE__*/_react.default.createElement(LegendIndicator, {
            className: "stx-legendIndicator-availability stx-legendIndicator-icon",
            iconName: iconName[indicator],
            color: color[indicator],
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 506,
              columnNumber: 25
            }
          }))), content)));
          cov_2r8wniypo().s[100]++;
          if (!_this2.props.datePicker) {
            cov_2r8wniypo().b[38][0]++;
            cov_2r8wniypo().s[101]++;
            if (_this2.props.onClick !== undefined) {
              cov_2r8wniypo().b[39][0]++;
              cov_2r8wniypo().s[102]++;
              dayCalText = /*#__PURE__*/_react.default.createElement(A, {
                className: "".concat((cov_2r8wniypo().b[40][0]++, isTheSameMonth) && (cov_2r8wniypo().b[40][1]++, 'stx-mini-day-in-same-month')),
                onClick: _this2.handleClick(dayText),
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 519,
                  columnNumber: 21
                }
              }, dayCalText);
            } else {
              cov_2r8wniypo().b[39][1]++;
              cov_2r8wniypo().s[103]++;
              if ((cov_2r8wniypo().b[42][0]++, action) && (cov_2r8wniypo().b[42][1]++, !hidden)) {
                cov_2r8wniypo().b[41][0]++;
                cov_2r8wniypo().s[104]++;
                dayCalText = /*#__PURE__*/_react.default.createElement(A, {
                  href: action,
                  target: "_blank",
                  __self: _this2,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 527,
                    columnNumber: 21
                  }
                }, dayCalText);
              } else {
                cov_2r8wniypo().b[41][1]++;
              }
            }
          } else {
            cov_2r8wniypo().b[38][1]++;
          }
          var dayClassName = (cov_2r8wniypo().s[105]++, 'g-mini-calendar-miniDay');
          cov_2r8wniypo().s[106]++;
          if ((cov_2r8wniypo().b[44][0]++, _this2.props.datePicker) && (cov_2r8wniypo().b[44][1]++, !disabled)) {
            cov_2r8wniypo().b[43][0]++;
            cov_2r8wniypo().s[107]++;
            dayClassName += ' g-mini-calendar-datepicker-day';
          } else {
            cov_2r8wniypo().b[43][1]++;
          }
          cov_2r8wniypo().s[108]++;
          if (dayText === _this2.props.selectedDay) {
            cov_2r8wniypo().b[45][0]++;
            cov_2r8wniypo().s[109]++;
            dayClassName += " selectedDay stx-".concat(indicator, "-color");
          } else {
            cov_2r8wniypo().b[45][1]++;
          }
          var dayDef = (cov_2r8wniypo().s[110]++, [/*#__PURE__*/_react.default.createElement(MiniDayWrapper, {
            w: [1 / 7],
            key: dayText,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 542,
              columnNumber: 17
            }
          }, _this2.props.datePicker ? (cov_2r8wniypo().b[46][0]++, /*#__PURE__*/_react.default.createElement(MiniDay, {
            isToday: (0, _utils2.isToday)(day),
            disabled: disabled,
            className: dayClassName,
            onClick: !disabled ? (cov_2r8wniypo().b[47][0]++, _this2.handleClick(dayText)) : (cov_2r8wniypo().b[47][1]++, function () {
              cov_2r8wniypo().f[37]++;
            }),
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 544,
              columnNumber: 21
            }
          }, dayCalText)) : (cov_2r8wniypo().b[46][1]++, /*#__PURE__*/_react.default.createElement(MiniDay, {
            color: color[indicator],
            isToday: (0, _utils2.isToday)(day),
            className: dayClassName,
            disabled: disabled,
            indicator: indicator,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 552,
              columnNumber: 21
            }
          }, dayCalText)))]);
          cov_2r8wniypo().s[111]++;
          return dayDef;
        }));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      cov_2r8wniypo().f[17]++;
      cov_2r8wniypo().s[36]++;
      if ((cov_2r8wniypo().b[16][0]++, props.onMonthChange) && (cov_2r8wniypo().b[16][1]++, props.month)) {
        cov_2r8wniypo().b[15][0]++;
        cov_2r8wniypo().s[37]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          month: props.month
        });
      } else {
        cov_2r8wniypo().b[15][1]++;
      }
      cov_2r8wniypo().s[38]++;
      return null;
    }
  }]);
}((_react.default.Component));
cov_2r8wniypo().s[112]++;
MiniCalendar.propTypes = {
  /** Pass the month for which we want to display the calendar */
  month: _propTypes.default.instanceOf(Date),
  /** Pass a function to be applied when another month is selected
   * if Provided the month property define the month displayed,
   * if not provided, the mont property is only the initialization
   * and the month displayed is handled by the component through the state
   */
  onMonthChange: _propTypes.default.func,
  /** Pass the content to display
   * TODO : to be refactored
   */
  days: _propTypes.default.objectOf(_propTypes.default.shape({
    indicator: _propTypes.default.node,
    action: _propTypes.default.string,
    info: _propTypes.default.string,
    content: _propTypes.default.element
  })),
  /**
   * A day selected for which we want to have more details it has the format YYYY-MM-DD
   */
  selectedDay: _propTypes.default.string,
  // The map of year -> [0,1,..] to define which month can be chosen
  months: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.number)),
  // If months is provided, it allows to force the display of the left
  forceBeforeMonth: _propTypes.default.bool,
  // If months is provided, it allows to force the display of the right
  forceAfterMonth: _propTypes.default.bool,
  // Disable selection dates in the past.
  showPastDates: _propTypes.default.bool,
  // If is provided, it will display a datepicker with all the dates from today available.
  datePicker: _propTypes.default.bool,
  // Method that can be passed to handle the click action and return the date selected.
  onClick: _propTypes.default.func,
  /** Date that want to hide all date before this date */
  hideBeforeDate: _propTypes.default.instanceOf(Date),
  /** Context Theme */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string
};
cov_2r8wniypo().s[113]++;
MiniCalendar.defaultProps = {
  month: new Date(),
  days: {},
  selectedDay: undefined,
  onMonthChange: undefined,
  months: undefined,
  closeSelectedDay: undefined,
  datePicker: false,
  onClick: undefined,
  forceBeforeMonth: false,
  forceAfterMonth: false,
  showPastDates: false,
  hideBeforeDate: null,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(MiniCalendar));